/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TemplateVisibility } from './TemplateVisibility';
import {
    TemplateVisibilityFromJSON,
    TemplateVisibilityFromJSONTyped,
    TemplateVisibilityToJSON,
    TemplateVisibilityToJSONTyped,
} from './TemplateVisibility';

/**
 * 
 * @export
 * @interface TemplateCreateFromWidgetRequest
 */
export interface TemplateCreateFromWidgetRequest {
    /**
     * 
     * @type {string}
     * @memberof TemplateCreateFromWidgetRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateCreateFromWidgetRequest
     */
    widgetKey: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateCreateFromWidgetRequest
     */
    category: string;
    /**
     * 
     * @type {TemplateVisibility}
     * @memberof TemplateCreateFromWidgetRequest
     */
    visibility?: TemplateVisibility;
    /**
     * 
     * @type {Array<string>}
     * @memberof TemplateCreateFromWidgetRequest
     */
    requiredLicenseFeatures?: Array<string>;
}



/**
 * Check if a given object implements the TemplateCreateFromWidgetRequest interface.
 */
export function instanceOfTemplateCreateFromWidgetRequest(value: object): value is TemplateCreateFromWidgetRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('widgetKey' in value) || value['widgetKey'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function TemplateCreateFromWidgetRequestFromJSON(json: any): TemplateCreateFromWidgetRequest {
    return TemplateCreateFromWidgetRequestFromJSONTyped(json, false);
}

export function TemplateCreateFromWidgetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplateCreateFromWidgetRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'widgetKey': json['widgetKey'],
        'category': json['category'],
        'visibility': json['visibility'] == null ? undefined : TemplateVisibilityFromJSON(json['visibility']),
        'requiredLicenseFeatures': json['requiredLicenseFeatures'] == null ? undefined : json['requiredLicenseFeatures'],
    };
}

export function TemplateCreateFromWidgetRequestToJSON(json: any): TemplateCreateFromWidgetRequest {
    return TemplateCreateFromWidgetRequestToJSONTyped(json, false);
}

export function TemplateCreateFromWidgetRequestToJSONTyped(value?: TemplateCreateFromWidgetRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'widgetKey': value['widgetKey'],
        'category': value['category'],
        'visibility': TemplateVisibilityToJSON(value['visibility']),
        'requiredLicenseFeatures': value['requiredLicenseFeatures'],
    };
}

